import classNames from 'classnames';
import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';

import { UiTypography } from '@/components/ui/Typography';
import { ApiUserCategoryType } from '@/modules/api';

import { OnboardingParamsTool } from '../../utils/paramsTool';

import { PreferencesListDefaultStyles } from './Default.styles';

export const OnboardingPreferencesList: React.FC<{
  children: NonNullable<React.ReactNode>;
}> = ({ children }) => {
  return (
    <PreferencesListDefaultStyles>{children}</PreferencesListDefaultStyles>
  );
};

export const OnboardingPreferencesOption: React.FC<{
  active: boolean;
  option: ApiUserCategoryType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
  shape?: 'circle' | 'square';
}> = ({ active, option, form, shape = 'circle' }) => {
  return (
    <label className="list-item">
      <Controller
        control={form.control}
        name="categories"
        render={({ field }) => (
          <input
            onChange={(event) => {
              const selectedCategories =
                OnboardingParamsTool.getParamsList('categories');

              if (event.target.checked) {
                field.onChange([...field.value, option.id]);
                selectedCategories.push(event.target.value);
              } else {
                field.onChange(
                  field.value.filter((x: string) => x !== option.id),
                );
                selectedCategories.splice(
                  selectedCategories.indexOf(event.target.value),
                  1,
                );
              }

              OnboardingParamsTool.setParam('categories', selectedCategories);
            }}
            type="checkbox"
            value={option.id}
            name={field.name}
            checked={active}
          />
        )}
      />
      <picture>
        <source srcSet={option.picture_url} />
        <img
          className={classNames('list-item-img', {
            checkedImg: active,
            'shape-circle': shape === 'circle',
            'shape-square': shape === 'square',
          })}
          alt="ai-partner"
        />
      </picture>
      <UiTypography
        variant="body-large"
        color="black"
        component="span"
        align="center"
      >
        {option.title}
      </UiTypography>
    </label>
  );
};
